import { cn } from '#/shared/lib/utils'

interface CampaignChoiceChipProps {
  label: string
  selected: boolean
  onClick: () => void
}

/** One pressable option in a row of them — the step picker's "When" chips. */
export function CampaignChoiceChip({
  label,
  selected,
  onClick,
}: CampaignChoiceChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        'cursor-pointer rounded-md border px-2.5 py-1.25 text-xs font-medium transition-colors',
        selected
          ? 'border-campaign-running bg-avatar-blue-soft text-campaign-running'
          : 'border-gray-200 bg-white text-warm-500 hover:bg-gray-50',
      )}
    >
      {label}
    </button>
  )
}
